/**
 *
 * @author: Matthew Rawson @ 21/09/2017 17:51
 * @description: multiLineEllipsis truncation
 * @notes:
 * - applying this to a component that enforces min-height may break the effect
 */
import {css} from "styled-components"

export const singleLine = css`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const multiLine = (linesToShow, lineHeight) => css`
  display: block; /* Fallback for non-webkit */
  display: -webkit-box;
  height: ${linesToShow * lineHeight}px; /* Fallback for non-webkit */
  -webkit-line-clamp: ${linesToShow};
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

/**
 * @param: linesToShow {number}
 * @param: lineHeight {number}
 * @returns: {string}
 */
export default (linesToShow, lineHeight) => {
  if (linesToShow === 1) {
    return singleLine
  }
  return multiLine(linesToShow, lineHeight)
}
